import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import moment from 'moment';

import useGetNameById from '../hooks/useGetNameById';

// One customer review row on the product page
const Comment = ({ authorId, commentText, createdAt }) => {

    const [name] = useGetNameById(authorId);

    return (
        <Box py='14px' borderBottom='1px solid' borderColor='raano.border' >
            <Box display='flex' justifyContent='space-between' alignItems='baseline' gap='8px' >
                <Text fontWeight={600} fontSize='14px' >{name}</Text>
                <Text fontSize='12px' color='raano.muted' >{moment(createdAt).format('DD MMM YYYY')}</Text>
            </Box>
            <Text mt='4px' fontSize='14px' lineHeight='1.55' color='blackAlpha.800' >{commentText}</Text>
        </Box>
    );
};

export default Comment;
